import { render } from "./Switcher.vue?vue&type=template&id=74312ac6&scoped=true"
import script from "./Switcher.vue?vue&type=script&lang=js"
export * from "./Switcher.vue?vue&type=script&lang=js"

import "./Switcher.vue?vue&type=style&index=0&id=74312ac6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74312ac6"],['__file',"src/views/Membership/component/PrivacySettings/Switcher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74312ac6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74312ac6', __exports__)) {
    api.reload('74312ac6', __exports__)
  }
  
  module.hot.accept("./Switcher.vue?vue&type=template&id=74312ac6&scoped=true", () => {
    api.rerender('74312ac6', render)
  })

}


export default __exports__